<template>
  <div class="flex flex-center">
    <img src="/assets/icon-app/favicon-96x96.png" class="pulse" style="height: 40px" alt="Loading" title="Loading"/>
  </div>
</template>

<script>
export default {
  name: "Spinner"
}
</script>

<style scoped>
  .pulse{
    animation: pulse 700ms linear infinite;
  }
  
  @-webkit-keyframes pulse {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
    50% {
      -webkit-transform: scale(0.95);
      -webkit-filter: grayscale(0.5);
      transform: scale(0.95);
      filter: grayscale(0.5);
    }
  }
</style>